import { present } from "~/kernel/dateTime/Day";
import to24HourFormat from "~/kernel/dateTime/to24HourFormat";
import type OpeningHoursModel from "~/models/company/TOpeningHours";

export default function OpeningHours({
  openingHours,
}: {
  openingHours: OpeningHoursModel;
}) {
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ] as const;

  return (
    <table>
      <tbody>
        {days.map((day) => {
          const opensMinute = openingHours[`${day}OpensMinute`];
          const closesMinute = openingHours[`${day}ClosesMinute`];

          if (
            typeof opensMinute === "number" &&
            typeof closesMinute === "number"
          ) {
            return (
              <tr key={day}>
                <td className="px-1">{present(day)}</td>
                <td className="px-1">
                  {to24HourFormat(opensMinute)}—{to24HourFormat(closesMinute)}
                </td>
              </tr>
            );
          }

          return null;
        })}
      </tbody>
    </table>
  );
}
